export const urls = {
  GET_RADNI_NALOG_ZA_MASINU:
    'DokRNPustanjeURad/vrati_dok_rn_pustanje_u_rad_za_id_masine',
};
